/* Created by Interactive 63 - https://interactive63.com */
/**
 * Which scene start triggers can be written as plain CSS, and which need the JavaScript runtime.
 */
import type { Trigger } from '../model/types';

/** Whether a trigger needs the JS runtime. Auto and hover pause-resume are pure CSS. */
export function triggerNeedsRuntime(trigger: Trigger): boolean {
  if (trigger.type === 'auto') return false;
  return !(trigger.type === 'hover' && trigger.mode === 'pause-resume');
}
